export const TOTAL_REVENUE = 'TOTAL_REVENUE';
export const MARGIN = 'MARGIN';
export const OCCUPATION = 'OCCUPATION';
export const DINER_REVENUE = 'DINER_REVENUE';
export const DINER_MARGIN = 'DINER_MARGIN';
export const PERCENTAGE_PROFIT = 'PERCENTAGE_PROFIT';
export const PRODUCT_SALES = 'PRODUCT_SALES';
export const REV_PASH = 'REV_PASH';
export const AVERAGE_DINER_TIME = 'AVERAGE_DINER_TIME';
export const AVERAGE_TICKET = 'AVERAGE_TICKET';
